"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@angular/common");
const core_1 = require("@angular/core");
const ngx_datatable_1 = require("@siemens/ngx-datatable");
const opportunity_1 = require("../shared/models/opportunity/opportunity");
const filtering_1 = require("../shared/services/filtering");
const object_1 = __importDefault(require("../shared/services/object"));
const table_component_1 = require("../table-component/table.component");
const users_service_1 = require("../../../shared/users/users.service");
const enums_1 = require("../@shared-types/opportunites/enums");
const customer_1 = require("../shared/models/customer/customer");
let OpportunityTableComponent = class OpportunityTableComponent extends table_component_1.GenericTableComponent {
    constructor(objectService, filteringService, userService, customerModel, opportunity, location) {
        super(filteringService, objectService, 'opportunityTable');
        this.customerModel = customerModel;
        this.opportunity = opportunity;
        this.location = location;
        this.filters = {};
        this.dataReady = false;
        this.sortBy = 'creationDate';
        this.ColumnMode = ngx_datatable_1.ColumnMode;
        this.SortType = ngx_datatable_1.SortType;
        this.getMongoData = () => __awaiter(this, void 0, void 0, function* () { });
        this.getTableData = (filter) => __awaiter(this, void 0, void 0, function* () {
            this.dataReady = false;
            const ops = yield this.opportunity.getAll(filter);
            this.tableData = ops;
            this.filteredData = ops;
            this.dataReady = true;
        });
        this.selectRow = (event) => {
            this.location.go(`/opportunities/opportunity/${String(event.selected[0].id)}`);
        };
        this.filterMode = 'SERVER';
        this.filters = {
            seller: {
                traversal: 'userId',
                translations: userService.getUserFilter(),
                value: String(userService.currentUserId()),
            },
            state: {
                traversal: 'state',
                translations: {
                    [enums_1.EOpportunityState.NEW]: 'Neu',
                    [enums_1.EOpportunityState.OPEN]: 'In Bearbeitung',
                    [enums_1.EOpportunityState.POSTPONED]: 'Zurückgestellt',
                    [enums_1.EOpportunityState.CLOSED]: 'Geschlossen',
                },
                value: `${enums_1.EOpportunityState.OPEN}, ${enums_1.EOpportunityState.POSTPONED}, ${enums_1.EOpportunityState.NEW}`,
            },
            customer: {
                traversal: 'customerId',
                translationFunction: (filterValue) => this.customerModel.getName(filterValue),
            },
        };
    }
};
OpportunityTableComponent = __decorate([
    (0, core_1.Component)({
        selector: 'opportunity-table',
        templateUrl: require('./opportunity-table.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof object_1.default !== "undefined" && object_1.default) === "function" ? _a : Object, typeof (_b = typeof filtering_1.FilteringService !== "undefined" && filtering_1.FilteringService) === "function" ? _b : Object, typeof (_c = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _c : Object, typeof (_d = typeof customer_1.CustomerModel !== "undefined" && customer_1.CustomerModel) === "function" ? _d : Object, typeof (_e = typeof opportunity_1.OpportunityModel !== "undefined" && opportunity_1.OpportunityModel) === "function" ? _e : Object, typeof (_f = typeof common_1.Location !== "undefined" && common_1.Location) === "function" ? _f : Object])
], OpportunityTableComponent);
exports.default = OpportunityTableComponent;
